export class MemoryArea {
  public readonly buffer: Uint8Array;
  private readonly view: DataView;

  constructor(public readonly sizeBytes: number) {
    this.buffer = new Uint8Array(sizeBytes);
    this.view = new DataView(this.buffer.buffer);
  }

  getBit(byteOffset: number, bitOffset: number): boolean {
    return ((this.buffer[byteOffset] ?? 0) & (1 << bitOffset)) !== 0;
  }

  setBit(byteOffset: number, bitOffset: number, value: boolean): void {
    if (value) {
      this.buffer[byteOffset] = (this.buffer[byteOffset] ?? 0) | (1 << bitOffset);
    } else {
      this.buffer[byteOffset] = (this.buffer[byteOffset] ?? 0) & ~(1 << bitOffset);
    }
  }

  getByte(byteOffset: number): number {
    return this.buffer[byteOffset] ?? 0;
  }

  setByte(byteOffset: number, value: number): void {
    this.buffer[byteOffset] = value;
  }

  getWord(byteOffset: number): number {
    return this.view.getUint16(byteOffset, false); // Big-endian (S7 style)
  }

  setWord(byteOffset: number, value: number): void {
    this.view.setUint16(byteOffset, value, false);
  }

  getInt(byteOffset: number): number {
    return this.view.getInt16(byteOffset, false);
  }

  setInt(byteOffset: number, value: number): void {
    this.view.setInt16(byteOffset, value, false);
  }

  getDWord(byteOffset: number): number {
    return this.view.getUint32(byteOffset, false);
  }

  setDWord(byteOffset: number, value: number): void {
    this.view.setUint32(byteOffset, value, false);
  }

  getFloat(byteOffset: number): number {
    return this.view.getFloat32(byteOffset, false);
  }

  setFloat(byteOffset: number, value: number): void {
    this.view.setFloat32(byteOffset, value, false);
  }

  reset(): void {
    this.buffer.fill(0);
  }
}
